import { getAdultMembers } from 'pages/AffordaHousehold/utils';

const checkHouseholdMembersHaveSignedConsent = (householdMembers) => {
  return householdMembers.length
    ? getAdultMembers(householdMembers).every((adultHouseholdMember) => {
        return Boolean(
          adultHouseholdMember?.additionalDetails?.consentSignature?.length,
        );
      })
    : false;
};

export default checkHouseholdMembersHaveSignedConsent;
